import type { SpacingDensity } from './types';

/**
 * Spacing classes for different densities
 */
export const markdownSpacingClasses: Record<SpacingDensity, { container: string; elements: string }> = {
  Compact: {
    container: 'space-y-4',
    elements: 'mb-4 last:mb-0',
  },
  Comfortable: {
    container: 'space-y-8',
    elements: 'mb-8 last:mb-0',
  },
  Spacious: {
    container: 'space-y-12',
    elements: 'mb-12 last:mb-0',
  },
};
